import React, { useContext } from 'react';
import twMerge from 'utilities/src/twMerge';
import useWindowSize from 'ui/src/hooks/useWindowSize';
import IconComponent from 'ui/src/components/Icon';
import ThemeContext from '../_themeContext';
import LinkOrButton from './_LinkOrButton';

interface Props {
  href: string;
  label: string;
  isActive: boolean;
  index?: number;
  hasNestedLinks?: boolean;
  areNestedLinksOpen?: boolean;
  onClick?: () => void;
  className?: string;
  contentClassName?: string;
}

export default function Link({
  href,
  label,
  isActive,
  index,
  hasNestedLinks,
  areNestedLinksOpen,
  onClick,
  className,
  contentClassName,
}: Props) {
  const { theme } = useContext(ThemeContext);
  const { isMdS } = useWindowSize({ mdS: 640 });
  const isDark = theme === 'dark';
  return (
    <LinkOrButton
      href={href}
      onClick={onClick}
      isLink={isMdS || !hasNestedLinks}
      className={twMerge(
        'mdL:font-bold mdL:items-start mdS:font-normal flex h-full items-center font-medium',
        'group-hover:mdS:bg-site-neutrals-50 transition-[background-color] duration-300',
        {
          'mdS:text-site-neutrals-600 mdS:bg-site-neutrals-50 transition-colors': isActive,
          'mdS:text-site-neutrals-0 mdS:bg-site-neutrals-900': isDark && isActive,
          'group-hover:mdS:text-site-neutrals-0 group-hover:mdS:bg-site-neutrals-900': isDark,
          'mdS:rounded-l-lg': index === 0,
        },
        className,
      )}
    >
      <span
        className={twMerge(
          'mdL:mx-8 mdL:py-4 mx-4 flex w-full items-center gap-2 text-nowrap py-3',
          contentClassName,
        )}
      >
        {label}
        {hasNestedLinks && (
          <IconComponent
            iconName="ChevronRightSmall"
            size="IconM"
            className={twMerge('group-hover:mdS:-rotate-90 rotate-90 bg-current', {
              '-rotate-90': areNestedLinksOpen,
            })}
          />
        )}
      </span>
    </LinkOrButton>
  );
}
